import React from "react";
import axios from "axios";

export const createVisaApplicationApi = async (alldata,token) => {

  try {
    let url = `https://visapro-api.tcore.online/api/v1/applications`;
    const response = await axios.post(url, alldata, {
        headers: {
          'Authorization': `Basic ${token}` 
        }});
    const visaApplication = {
      data: response.data,
    };
    return visaApplication;
  } catch (error) {
    const visaApplication = {
      error: error,
    };
    return visaApplication;
  }
};
